<div appHeightWatcher>
  @for (p of myExerciseEventsByParticipant | keyvalue; track p) {
    <div>
      <b>
        {{this.participantIdToParticipant.get(p.key).firstname}}
        {{this.participantIdToParticipant.get(p.key).lastname}}
      </b>
      <ul class="list-group">
        @for (eee of p.value; track eee) {
          <li
            class="list-group-item"
            >
            <app-moduploadvideo
              [participant]="this.participantIdToParticipant.get(p.key)"
              [pack]="this.pack"
              [ev]="eee"
              >
            </app-moduploadvideo>
          </li>
        }
      </ul>
    </div>
  }
</div>